var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header',{attrs:{"theme":_vm.theme},on:{"toggle-theme":_vm.toggleTheme}}),_c('router-view'),_c('Footer'),_c('div',{staticClass:"backto-top",class:{ show: _vm.backToTopVisible },staticStyle:{"scroll-behavior":"smooth"},on:{"click":_vm.scrollToTop}},[_vm._m(0)])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('i',{attrs:{"data-feather":"arrow-up"}})])
}]

export { render, staticRenderFns }